// Deck-Identität für die Abfragen des Katalogs: die Umrechnung zwischen numerischer DB-ID
// und UI-ID („virtual_25") in beide Richtungen und der Query-Key, unter dem die Kategorien
// liegen. Alles steht hier, weil zwei Seiten denselben Wert treffen müssen — der Katalog
// liest die Kategorien, die Kategorie-Verwaltung des Editors invalidiert sie.

/**
 * Numerische DB-ID eines Decks. `deck.id` ist eine UI-ID wie „virtual_25", die Zahl
 * liegt in `deck.origid`; fehlt sie, wird sie aus der UI-ID gelesen.
 */
export function deckNumericId(deck) {
  if (typeof deck?.origid === 'number') return deck.origid;
  const match = String(deck?.id ?? '').match(/(\d+)$/);
  return match ? Number(match[1]) : null;
}

/** Query-Key der Kategorien eines virtuellen Decks (numerische ID). */
export function deckCategoriesKey(deckId) {
  return ['deck-categories', deckId];
}

/**
 * UI-ID eines virtuellen Decks („virtual_25") aus seiner numerischen DB-ID. Umkehrung von
 * `deckNumericId` für die Stellen, die ein Deck unter seiner UI-ID adressieren — etwa der
 * Speicher der Kartenvorschläge, dessen Schlüssel der Absender als Zeichenkette schickt.
 */
export function deckUiId(numericId) {
  return numericId == null ? null : `virtual_${numericId}`;
}
